<div class="dialog-view-container" #dialogView>
    @for (message of dialogViewMessages; track $index) {
        @if (isAssistantMessage(message.role)) {
            <craig-assistant-message [message]="message.content"></craig-assistant-message>
            @if (message.requestId) {
                <craig-response-feedback [requestId]="message.requestId"></craig-response-feedback>
            }
        } @else {
            <craig-user-message [message]="message.content"></craig-user-message>
        }
    }

    @if (responseLoaderShowed) {
        <craig-response-loader></craig-response-loader>
    }
</div>
